<template>
  <f7-page no-toolbar  name="financial" class="page-center" @page:init="onPageInit">
    <f7-navbar innerClass="navbar-inner">
      <f7-nav-left>
        <f7-link @click="$f7router.navigate('/home/')">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>{{ $t("luckbox_001") }}</f7-nav-title>
      <f7-nav-right>
        <f7-link popup-open=".pending-popup">
          <i  style="font-size: 20px;margin-right: 10px;" class="bi-file-earmark-text-fill" ></i>
        </f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="content">
      <div v-show="rule.Enable" @click="openRule()" class="rule">{{ $t("luckbox_022") }}</div>

      <div class="task-list">
        <div class="rotate-warpper">
          <div class="wheel-wrapper" style="position: relative; width: 280px; height: 280px;">
            <!-- 背景圈 -->
            <img
              class="rotating-bg"
              src="../../static/images/yt999/activity/133.png"
              width="320"
              height="320"
              alt="bg"
            />

            <!-- 幸运转盘 -->
            <LuckyWheel
              class="lucky-wheel"
              ref="myLucky"
              width="280px"
              height="280px"
              :prizes="prizes"
              :blocks="[]"  
              :buttons="buttons"
              @start="startCallback(false)"
              @end="endCallback"
              style="position: absolute; left: 0px; top: 0px;"
            />
          </div>

        </div>
        <div style="width: 100%;text-align: center;margin-top:-20px;"><img src="../../static/images/yt999/activity/dibu.png" width="65%" ></div>
      </div>
      <div style="text-align: center;color: white;">
        {{ $t("luckbox_002") }}<br />
        （<span style="color: #fff">{{ remaining }}</span
        >）
      </div>
    </div>
    <van-tabs class="van" @change="onTabChange" >
      <van-tab :title="$t('luckbox_010')" style="font-weight: bold" >
        <ul style="padding: 0 10px">
          <li class="title">
            <div style="width: 50%">{{ $t("luckbox_029") }}</div>
            <div style="width: 50%">{{ $t("luckbox_012") }}</div>
          </li>
          <div v-if="historytopgetList.length>0">
            <li v-for="(item, index) in historytopgetList.slice(0, 10)" :key="index" style="display: flex; border-bottom: 1px solid rgb(237 237 237)">
              <!-- <div class="d1">
                <img :src="`../../static/images/yt999/box/${item.LuckyNumber}.png`" alt="" width="50px" />
                <span class="boxnum">{{ item.LuckyNumber }}</span>
              </div> -->
              <div class="d3" style="font-size: 13px">{{ item.UserName }}</div>
              <div class="d2" >
                <span v-if="item.IsPlayForFun" class="fun"></span>
                <span v-if="item.WinTypeCode=='POINTS'">
                  {{ $t("luckbox_038") }} + {{ item.WinAmount | formatCurrency2 }}
                </span>
                <span v-else>
                  <span class="symbol">{{ currencySymbol }}</span>{{ item.WinAmount | formatCurrency2 }}
                </span>
              </div>
            </li>
          </div >
          
          <div v-else style="padding: 80px;text-align: center;">
            <img :src="`../../static/images/yt999/noData_${ $f7.params.currLang }.png`" width="100%" :onerror="`this.onerror=''; src='../../static/images/yt999/noData_enUS.png'`" alt="No data" >
          </div>
        </ul>
      </van-tab>
    </van-tabs>

    <div class="dialog ruledialog">
      <div class="dialog-inner">
        <div class="dialog-title" style="height: 35px; line-height: 35px">
          <h5>{{ $t("luckbox_022") }}</h5>
        </div>
        <div class="dialog-text">
          <f7-block class="block-message">
            <div class="block-content" v-html="rule.RulesContent" style="height: 350px"></div>
            <f7-block-footer>
              <f7-row no-gap>
                <f7-col tag="span">
                  <f7-button large class="btn-next border-radius-left" @click="closeRule()">{{ $t("common_0001") }}</f7-button>
                </f7-col>
              </f7-row>
            </f7-block-footer>
          </f7-block>
        </div>
      </div>
    </div>

    <van-popup v-model="bonusv0" closeable close-icon="close" class="bonusv0">
      <div>
        <div style="height: 90px">
          <img v-if="openData.WinTypeCode=='POINTS'" :src="`../../static/images/yt999/jifenbg.png`" alt="" style="top: -100px;" />
          <img v-else :src="`../../static/images/yt999/bonusred.png`" alt="" srcset="" />
          <!-- <span class="jifentxt">{{ $t("luckbox_038") }}</span> -->
        </div>
        <div v-show="bonusAmount > 0">
          <div style="font-size: 20px; font-weight: bold; margin-bottom: 10px">{{ $t("luckbox_030") }}</div>
          <div style="margin-bottom: 15px; color: #606060">{{ $t(openData.WinTypeCode=='POINTS'?"luckbox_039":"luckbox_031") }}</div>
          <div>
            <span class="symbol" style="font-size: 14px; color: red" v-show="openData.WinTypeCode!=='POINTS'">{{ currencySymbol }}</span>
            <span style="font-size: 25px; color: red; font-weight: bold">{{ bonusAmount | formatCurrency2 }}</span>
          </div>
          <div style="margin: 20px 0; color: #606060;padding: 0 15px;">{{ $t("luckbox_032") }}</div>
        </div>

        <div v-show="bonusAmount <= 0">
          <div style="font-size: 20px; font-weight: bold; margin-bottom: 10px">{{ $t("luckbox_033") }}</div>
          <div style="margin-bottom: 15px; color: #606060">{{ $t("luckbox_034") }}</div>
        </div>
        <div class="go" @click="closeBonusv0()">{{ $t("luckbox_035") }}</div>
      </div>
    </van-popup>

    <f7-popup v-show="showBalanceInfoPopup" class="pending-popup"   @popup:close="closedBalanceInfo">
      <f7-page>
        <f7-navbar :title="$t('luckbox_037')">
          <f7-nav-right>
            <f7-link popup-close>
              <i class="f7-icons" >multiply_circle</i>
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <div>
          <ul class="van " style="text-align: center;background: #fff;">
            <li class="title" style="border-bottom: 1px solid #e3e3e3;">
              <div style="width: 50%">{{ $t("luckbox_013") }}</div>
              <div style="width: 50%">{{ $t("luckbox_012") }}</div>
            </li>
            <li v-for="(item, index) in memberLuckyDrawList" :key="index" style="display: flex;border-bottom: 1px solid #e3e3e3;">
              <div class="d3" style="font-size: 12px;line-height: 40px;">{{ item.CreateTS | time }}</div>
              <div class="d2" style="font-size: 12px;line-height: 40px;font-weight:100;">
                <span v-if="item.WinTypeCode=='POINTS'">
                  {{ $t("luckbox_038") }} + {{ item.WinAmount | formatCurrency2 }}
                </span>
                <span v-else>
                  <span class="symbol">{{ currencySymbol }}</span>{{ item.WinAmount | formatCurrency2 }}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </f7-page>
    </f7-popup>

  </f7-page>
</template>

<script>
import { getCookie, getStore } from "@/config/utils";
import {
  luckydrawbox,
  getLuckyDrawChanceDetail,
  getMerchantluckydrawboxbymemberlist,
  getMemberluckydrawboxhistorytopget,
  getmerchantluckydrawboxrulesbymemberget,
  memberluckydrawboxhistorybymemberlist,
} from "../../axios/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      bonusv0: false,
      luckyNumber: -1,
      winAmount: 0,
      isPlayForFun: true,
      remaining: 0,
      merchantluckydrawboxbymemberlist: [],
      memberLuckyDrawList: [],
      currencySymbol: "",
      Ygo: false,
      Ngo: false,

      updateTime: null,
      dialog: 0,
      openbtn: false,
      rule: {},

      // 幸运转盘
      blocks: [{ padding: "18", background: "#f5c043", imgs: [{ src: "../../../static/images/yt999/activity/133.png", width: 280, height: 280, rotate: true }] }],
      prizes: [],
      buttons: [
        {
          radius: "30%",
          pointer: true,
          // fonts: [{ text: this.$t("activity_center_0034"), top: "-10px", fontColor: "#f9da4a", fontSize: 18 }],
          // fonts: [{ text: this.$t("activity_center_0034"), top: "-10px", fontColor: "#f9da4a", fontSize: 18 }],
          // imgs: [{ src: "../../../static/images/yt999/activity/11.png", width: 74, height: 100, top: "-60px" }],
          imgs: [{ src: "../../../static/images/yt999/activity/11.png", width: 74, height: 74, top: "-40px" }],
        },
      ],
      running: false,
      bonusAmount: 0,
      historytopgetList: [],
      showBalanceInfoPopup: true,
      openData: {}
    };
  },
  watch: {},
  computed: {},
  methods: {
    onPageInit() {
      // if ("luckybox" == this.$f7router.currentRoute.name) {
      //   this.updateTime = setInterval(() => {
      //     this.nagetMemberluckydrawboxhistorytopget();
      //   }, 5000);
      // }
    },
    
    closedBalanceInfo() {
      this.showBalanceInfoPopup = false;
    },
    closeBonusv0() {
      this.bonusv0 = false;
    },
    async startCallback(flag) {
      const self = this;
      let index = this.prizes.length - 1;

      if (this.running) {
        return;
      }
      if (!getCookie("zz")) {
        const promtLoadingGame = this.$f7.dialog
          .create({
            title: "",
            text: this.$t("common_need_login"),
            cssClass: "dialog-preloadgame",
          })
          .open();
        setTimeout(() => {
          promtLoadingGame.close();
          this.$f7router.navigate("/login/");
        }, 1500);
        return;
      }
      if (this.remaining == 0) {
        self.$f7.dialog.alert(this.$t("luckbox_028"), this.$t("common_0004"));
        return false;
      }
      this.running = true;

      this.$refs.myLucky.play(); //开始转动

      const params = { IsPlayForFun: flag, MemberChooseIndex: 0, TotalChooseCount: 3 }; //IsPlayForFun: true=试玩 / false=正式玩
      const d = { data: JSON.stringify(params) };
      luckydrawbox(d).then((data) => {
        if (data.Code === "NoError") {
          self.winAmount = data.Data.WinAmount;
          self.openData = data.Data;
          index = self.prizes.findIndex((item) => item.BonusAmount == data.Data.WinAmount);

          setTimeout(() => {
            self.$refs.myLucky.stop(index); 
          }, 5000);
          this.nagetLuckyDrawChanceDetail(); //更新剩余次数
        } else {
          let loginLoading = self.$f7.dialog
            .create({
              title: "",
              text: data.Data,
              cssClass: "dialog-preloadgame",
            })
            .open();
          setTimeout(() => {
            loginLoading.close();
          }, 2000);
        }

        self.running = false;
      });
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      const self = this;
      self.bonusv0 = true;
      self.bonusAmount = prize.BonusAmount;
      self.memberluckydrawboxhistorybymemberlist(); //更新中奖记录
    },

    openRule() {
      this.$f7.params.dialog.closeByBackdropClick = true; //点击背景关闭
      this.$f7.dialog.open(".ruledialog", true);
    },
    closeRule() {
      this.$f7.dialog.close(".ruledialog");
    },

    nagetLuckyDrawChanceDetail() {
      getLuckyDrawChanceDetail().then((data) => {
        if (data.Code === "NoError") {
          this.remaining = data.Data.LuckyDrawBox_PlayForRealTotal - data.Data.LuckyDrawBox_PlayForRealCurrent;
          if (data.Data.LuckyDrawBox_PlayForRealTotal - data.Data.LuckyDrawBox_PlayForRealCurrent > 0) {
            this.Ygo = true;
          }
          if (data.Data.LuckyDrawBox_PlayForFunTotal - data.Data.LuckyDrawBox_PlayForFunCurrent > 0) {
            this.Ngo = true;
          }
        }
      });
    },
    nagetMerchantluckydrawboxbymemberlist() {
      getMerchantluckydrawboxbymemberlist().then((data) => {
        if (data.Code === "NoError") {
          this.merchantluckydrawboxbymemberlist = data.Data;
          if (!Array.isArray(this.merchantluckydrawboxbymemberlist)) return;
          const awardList = this.merchantluckydrawboxbymemberlist.map((item, i) => {
            return {
              BonusAmount: item.WinAmount,
              fonts: [
                { text: item.WinTypeCode=='POINTS'?this.$options.filters.formatCurrency2(item.WinAmount):this.currencySymbol+' '+this.$options.filters.formatCurrency2(item.WinAmount),
                 top: "10%", fontSize: "13px", fontWeight:"700",fontColor: '#c12f23' },
                // { text: this.currencySymbol, top: "40%", fontSize: "12px" }
              ],
              // fonts: [{ text: this.currencySymbol, top: "40%", fontSize: "12px" }],
              
              imgs: [{ src: item.WinTypeCode=='POINTS'?"../../static/images/yt999/activity/jifen.png":"../../static/images/yt999/activity/hongbao.png", width: 22, height: 21, rotate: true, top: "40%" }],
              // background: i % 2 ? "#f5c043" : "#fcefc4",
              background: (i % 3 === 0)? "#f5c043": (i % 3 === 1)? "#e5b1ad": "#fcefc4",
              
              };
          });
          // awardList.push({
          //   BonusAmount: 0,
          //   fonts: [{ text: this.$t("activity_center_0035"), top: "10%", fontSize: "16px" }],
          //   background: "#c7c1b0",
          // });
          this.prizes = awardList;
        }
      });
    },

    memberluckydrawboxhistorybymemberlist() {
      memberluckydrawboxhistorybymemberlist().then((data) => {
        if (data.Code === "NoError") {
          this.memberLuckyDrawList = data.Data;
        }
      });
    },

    getMemberluckydrawboxhistorytopget() {
      getMemberluckydrawboxhistorytopget().then((data) => {
        if (data.Code === "NoError") {
          this.historytopgetList = data.Data;
        }
      });
    },
    
    nagetmerchantluckydrawboxrulesbymemberget() {
      getmerchantluckydrawboxrulesbymemberget().then((data) => {
        if (data.Code === "NoError") {
          this.rule = data.Data;
        }
      });
    },
    onTabChange() {
      // 阻止默认的页面滚动行为
      window.scrollTo(0, 0); // 保持页面不滚动
    },
  },
  created() {
    this.currencySymbol = getStore("currencySymbol");
  },
  mounted() {
    const self = this;
    this.nagetLuckyDrawChanceDetail();
    this.nagetMerchantluckydrawboxbymemberlist();
    this.memberluckydrawboxhistorybymemberlist();
    this.getMemberluckydrawboxhistorytopget();
    this.updateTime = setInterval(() => {
      this.getMemberluckydrawboxhistorytopget();
    }, 5000);
    this.nagetmerchantluckydrawboxrulesbymemberget();
  },
  destroyed() {
    clearInterval(this.updateTime);
    window.location.reload();
  },
};
</script>
<style lang="less" scoped>
::v-deep .navbar-inner{    //头部颜色更换
  color: white;
  background: linear-gradient(to right, #3694ec, #4397f0);
  a{
    color: white;
  }
}
::v-deep .page-content {
    // background: var(--f7-THEME-color);
}
::v-deep .rotating-bg {
  position: absolute;
  left: -20px;
  top: -20px;
  margin: 0 auto;
  animation: spin 6s linear infinite;
  transform-origin: center center;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.content {
  padding: 10px;
  background: #29303a;
  background-image: url("../../static/images/yt999/box/luckboxbg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  padding-top: 215px;
  position: relative;
  
  background-color: #0887b2;
  .rule {
    color: white;
    position: absolute;
    top: 25px;
    right: 20px;
    z-index: 200;
    background: var(--f7-THEME-color);
    height: 25px;
    line-height: 25px;
    text-align: center;
    border-radius: 25px;
    padding: 0 12px;
  }
  // height: 100%;
  .box {
    width: 100%;
    height: 330px;
    margin-top: 290px;
    display: grid;
    grid-template-columns: auto auto auto;
    justify-content: center;
    color: white;
    font-size: 20px;
    text-align: center;
    line-height: 90px;

    div {
      width: 90px;
      height: 90px;
      background: url("../../static/images/yt999/item.png");
      background-size: 100% 100%;
      margin: 10px;
      box-sizing: border-box;
    }

    .active {
      border: 1px solid white;
      border-radius: 10px;
    }
  }

  .dan {
    // background: white;
    text-align: center;
    position: relative;

    .bigbox {
      position: relative;
      z-index: 10;
      width: 350px;
      margin: 0 auto;
      // background: url('../../static/images/yt999/box/quan.png');
    }

    .yu {
      // width: 186px;
      // margin: 0 auto;
      // height: 40px;
      // line-height: 41px;
      // background: #deb035;
      // font-size: 17px;
      // color: white;
      // border-radius: 10px;
      // margin-bottom: 20px;
      font-size: 17px;
      position: absolute;
      top: 377px;
      width: 100%;
    }

    .fen {
      width: 85%;
      margin: auto;
      //margin: 20px 0;
      font-size: 16px;
      text-decoration: underline;
    }

    .yin {
      width: 100%;
      height: 165px;
      position: absolute;
      top: 217px;
      left: 0;
    }

    .quan {
      width: 422px;
      position: absolute;
      top: -79px;
      left: -53px;
    }
  }

  .mian {
    text-align: center;
    width: 300px;
    height: 40px;
    line-height: 40px;
    background: var(--f7-THEME-orderSub);
    margin: 20px auto;
    border-radius: 10px;
    font-size: 14px;
  }
  .go {
    width: 300px;
    height: 46px;
    line-height: 46px;
    font-size: 16px;
    border: none;
    border-radius: 10px !important;
    margin: 0 auto;
    text-transform: none;
    background: var(--f7-THEME-color);
    color: black;
    position: relative;
    z-index: 100;
  }

  .open {
    width: 210px;
    height: 82px;
    margin: 0 auto;
    position: relative;
    bottom: 83px;
    z-index: 20;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    left: -3px;
    div {
      position: relative;
      overflow: hidden;
    }

    img {
      width: 76px;
      // height: 90px;
    }

    .opentext {
      position: absolute;
      line-height: 65px;
      font-size: 26px;
      left: 26px;
      top: 0;
    }
  }

  .opactive {
    background-image: url(../../static/images/yt999/box/click.gif);
    background-size: 86% 99%;
    border-radius: 10px;
    background-position-x: 10px;
    background-position-y: 7px;
    background-repeat: no-repeat;
  }

  .nogo {
    background: #d6d6d6;
    height: 46px;
    line-height: 46px;
    font-size: 16px;
    width: 90%;
    border: none;
    border-radius: 10px !important;
    margin: 0 auto;
    text-transform: none;
  }

  .task-list {
    // margin: 16px;
    // padding: 16px;
    border-radius: 8px;
    .task-header {
      .label {
        font-size: 14px;
      }
      .value {
        font-size: 16px;
        font-weight: bold;
        color: red;
      }
    }

    .rotate-warpper {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      .lucky-wheel {
        position: relative;
        z-index: 2;
      }
      .bottom {
        width: 280px;
        position: absolute;
        bottom: -10px;
        z-index: 1;
      }
    }
  }
}

.van {
  padding: 10px;
  background: var(--f7-THEME-color);
  font-size: 12px;
  ul li {
    height: 52px;
    text-align: center;
  }

  .title {
    display: flex;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid rgb(237, 237, 237);
    font-weight: bold;
  }

  .d1 {
    width: 33%;
    position: relative;

    .boxnum {
      position: absolute;
      top: 14px;
      font-weight: bold;
      font-size: 17px;
      width: 100%;
      text-align: center;
      left: 0;
    }
  }

  .d2 {
    width: 50%;
    line-height: 55px;
    font-size: 13px;
    font-weight: bold;
    .fun {
      width: 10px;
      height: 10px;
      display: inline-block;
      background: #ccc;
      border-radius: 10px;
      position: absolute;
      left: -5px;
      top: 23px;
    }
  }

  .d3 {
    width: 50%;
    line-height: 55px;
    font-size: 16px;
  }

  ::v-deep.van-tabs--line .van-tabs__wrap {
    border-radius: 10px 10px 0 0;
  }

  ::v-deep .van-tab__text--ellipsis {
    font-weight: bold;
  }

  .fun2 {
    width: 10px;
    height: 10px;
    display: inline-block;
    background: #ccc;
    border-radius: 10px;
    margin: 10px 10px 0 10px;
  }

  ::v-deep .van-tab--active {
    color: #323233;
    font-weight: 500;
    // background: linear-gradient(to bottom, var(--f7-THEME-color), #fff);
    background: linear-gradient(179.62deg, #009DD2 0.33%, #FFFFFF 99.67%);
    border-radius: 10px 10px 0 0;
  }

  ::v-deep .van-tabs__line {
    display: none;
  }

  ::v-deep .van-tabs__nav {
    background-color: #f0f0f0;
  }
}

::v-deep .van-tabs__content {
  background: white;
 
}
::v-deep .page-content::after {
  height: 0;
}

.ruledialog {
  width: 86%;
  margin: 0 7%;
  background-color: white !important;
  left: 0;

  .dialog-inner {
    padding: 0;
    text-align: left;

    .dialog-title {
      text-align: center;
      position: relative;
      font-size: 18px;
      padding-bottom: 4px;
      h3 {
        margin: 0 0 2px 0;
      }

      h5 {
        margin: 0;
        font-weight: normal;
      }
    }

    .dialog-title:after {
      content: "";
      position: absolute;
      z-index: 1;
      background: url(../../static/images/yt999/light.png) no-repeat;
      background-size: var(--f7-size-percent-100) var(--f7-size-percent-100);
      height: var(--f7-height-size-2);
      width: 100%;
      display: block;
      top: auto;
      right: auto;
      bottom: 0;
      left: 0;
      transform-origin: 50% 100%;
      transform: scaleY(1);
      transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
    }

    .dialog-text {
      .block-message {
        margin: var(--f7-margin-size-0);
        padding: var(--f7-padding-size-0);
        width: var(--f7-width-size-pt100);

        .block-content {
          padding: var(--f7-padding-size-8) var(--f7-padding-size-10);
          height: 300px;
          overflow: hidden scroll;
          font-size: 15px;
          background:white;
        }

        .row-toggle {
          margin: 10px 10px 0;

          span {
            color: var(--f7-dialog-button-text-color-right);
          }

          .toggle {
            margin-top: var(--f7-margin-size-f2);
          }
        }

        .block-footer {
          margin-top: 8px;

          .row.no-gap {
            --f7-grid-gap: 0px;
          }

          .button {
            height: 50px;
            line-height: 50px;
            color: var(--f7-color-white);
            font-size: var(--f7-px-16);
          }

          .btn-next {
            background: var(--f7-dialog-button-bg-color-right);
            color: var(--f7-dialog-button-text-color-right);
          }

          .btn-next.button-disabled {
            opacity: 0.6;
            // color: var(--f7-dialog-button-text-disable-color-right) !important;
          }

          .btn-close {
            background-color: var(--f7-dialog-button-bg-color-left);
            color: var(--f7-dialog-button-text-color-left);
            border-radius: 0;
          }
        }
      }
    }
  }
}
.bonusv0 {
  width: 80%;
  //  height: 40%;
  border-radius: 20px;
  text-align: center;
  overflow-y: visible;
  background: white;
  img {
    width: 100%;
    position: relative;
    top: -68px;
    z-index: 2005;
  }
  .go {
    width: 70%;
    height: 40px;
    line-height: 40px;
    background: var(--f7-THEME-color);
    margin: 0 auto;
    border-radius: 10px;
    color: white;
    font-weight: bold;
    margin-bottom: 33px;
  }
  ::v-deep .van-popup__close-icon--top-right {
    top: auto;
    right: 45%;
    bottom: -40px;
    display: none;
  }
  ::v-deep .van-popup__close-icon {
    font-size: 33px;
  }
  .jifentxt{
    position: absolute;
    top: 0px;
    z-index: 100000;
    display: block;
    width: 100%;
    text-align: center;
    padding-left: 5px;
    font-weight: bold;
  }
}
</style>
